export default __webpack_public_path__ + "static/media/1-Cloudxier-CECTSustainabilityAwards2.c5744cbf.png";